import { InteracEditEmailRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function usePostEditInterac(bearer: string) {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const editInterac = async (requestParams: InteracEditEmailRequest) => {
    const response = await api.postEditInteracEmail(requestParams, source, bearer);
    return response;
  };

  return {
    editInterac,
  };
}
